module.exports = __webpack_public_path__ + "static/img/vip_gift.7113da4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip_gift.png
// module id = hQCX
// module chunks = 0